/**
 * Single source of truth for rendering an invoice number from billing settings.
 * Used by the invoice number preview in the company settings invoice tab (via
 * `InvoiceNumberPipe`) and by the provisional draft number in Compliant Mode.
 */
export function formatInvoiceNumber(
  nextInvoiceNumber: number | null | undefined,
  invoiceNumberNumberOfDigits: number | null | undefined,
  invoiceNumberCustomPrefix?: string | null,
): string {
  const padded = String(nextInvoiceNumber ?? 1).padStart(
    invoiceNumberNumberOfDigits ?? 8,
    '0',
  );
  return `${invoiceNumberCustomPrefix ?? ''}${padded}`;
}
